export default e => {
  e.preventDefault();
  e.stopPropagation();
};
